import { BLAdmin, IReturnableActivity } from "types/working-model";
import { getInitials } from "utils/utils";

export type ParsedUserFromActivity = {
	name: string;
	picture: string | null;
	initials: string;
}
export const parseUserFromActivity = (activityLog: IReturnableActivity, adminMap: Map<number, BLAdmin>): ParsedUserFromActivity => {
	const admin = adminMap.get(activityLog.bl_admin);
	if (!admin) {
		return {
			name: 'Removed user',
			picture: '',
			initials: ''
		};
	}
	const profile = admin.profile;
	const { first_name, last_name, picture } = profile;
	return {
		name: first_name && last_name ? `${first_name} ${last_name}` : admin.email,
		picture,
		initials: getInitials(admin)
	};
};


export const ACTIVITY_MODAL_ID = 'activity-log-modal';

export const hasMoreToScroll = (modal: HTMLDivElement | null) => {
	if (!modal) return false;

	const modalBody = modal.querySelector('.modal-body');
	const modalHeader = modal.querySelector('.modal-header');
	if (modalBody && modalHeader) {
		const filledHeight = modalBody.scrollHeight + modalHeader.clientHeight;
		return modal.clientHeight > filledHeight;
	}

	return false;
};